export const siteUrl = 'https://aframusic.co.uk';
export const siteName = 'Afra Music';

export const pages = {
	'/about': {
		title: 'Music Services - Music Therapy, Live Music and Piano Lessons in South West/South Wales',
		description: 'Music Services - Music Therapy, Live Music and Piano Lessons in South West/South Wales',
	},
	'/services/music-therapy': {
		title: 'Music Therapy | Afra Jurkiewicz, South West/South Wales',
		description: 'Explore individual and group music therapy with Afra Jurkiewicz, a Nordoff-Robbins-trained music therapist based in Herefordshire. No music experience needed.',
	},
	'/services/piano-teaching': {
		title: 'Piano Lessons in South West/South Wales | Afra Music',
		description: 'Piano lessons for children and adults in South West/South Wales with Afra Jurkiewicz. Get in touch to discuss lessons for you or your child.',
	},
	'/performances/interactive-music': {
		title: 'Interactive Music for Schools in South West & South Wales | Afra Music',
		description: 'Inclusive live music performances for primary schools and special educational settings across the South West and South Wales. Explore sessions and enquire.',
		image: '/live.jpg',
		imageAlt: 'Interactive live music performance',
	},
	'/performances/meet-the-team': {
		title: 'Meet the Musicians | Afra Music',
		description: 'Meet Michael Warburton and Mikey Ponsford, the musicians working with Afra to bring inclusive, interactive live music performances to schools.',
	},
	'/testimonials': {
		title: 'Music Therapy & Live Music Testimonials | Afra Music',
		description: 'Read feedback about Afra’s music therapy, community music and interactive performances from the people and organisations she has worked with.',
	},
	'/gallery': {
		title: 'Live Music & Community Music Gallery | Afra Music',
		description: 'See photos of school music performances, folk festivals and community choir projects with Afra, including Riverbank School in Cardiff.',
		image: '/riverbank_main.jpg',
		imageAlt: 'Live music at Riverbank School, Cardiff',
	},
	'/contact': {
		title: 'Contact Afra | Music Therapy, Piano Lessons & Live Music',
		description: 'Contact Afra Jurkiewicz to discuss music therapy, piano lessons or interactive school performances. Based in Herefordshire, serving the South West and South Wales.',
	},
};

export const redirects = {
	'/': '/about',
	'/services': '/services/music-therapy',
	'/performances': '/performances/interactive-music',
	'/services/interactive-music': '/performances/interactive-music',
};

export function getPageSeo(pathname) {
	const path = pathname.replace(/\/+$/, '') || '/';
	const canonicalPath = redirects[path] || path;
	return {
		...(pages[canonicalPath] || {
			title: 'Page not found | Afra Music',
			description: 'This page could not be found. Explore Afra’s music services or get in touch.',
			noindex: true,
		}),
		url: siteUrl + canonicalPath,
	};
}

export function getStructuredData(meta) {
	return {
		'@context': 'https://schema.org',
		'@graph': [
			{
				'@type': 'Person',
				'@id': `${siteUrl}/#afra`,
				name: 'Afra Jurkiewicz',
				url: `${siteUrl}/about`,
				jobTitle: 'Music therapist and musician',
				email: 'afra.musictherapy@gmail.com',
				telephone: '+447481402902',
				sameAs: ['https://www.linkedin.com/in/afra-jurkiewicz-6637174a/'],
			},
			{
				'@type': 'WebSite',
				'@id': `${siteUrl}/#website`,
				url: `${siteUrl}/`,
				name: siteName,
				publisher: { '@id': `${siteUrl}/#afra` },
				inLanguage: 'en-GB',
			},
			{
				'@type': 'WebPage',
				'@id': `${meta.url}#webpage`,
				url: meta.url,
				name: meta.title,
				description: meta.description,
				isPartOf: { '@id': `${siteUrl}/#website` },
				about: { '@id': `${siteUrl}/#afra` },
				inLanguage: 'en-GB',
			},
		],
	};
}

// The build and client navigation share the same metadata definitions.
export function getMetaTags(meta) {
	const tags = [
		['name', 'description', meta.description],
		['name', 'robots', meta.noindex ? 'noindex,follow' : 'index,follow,max-image-preview:large'],
		['property', 'og:type', 'website'],
		['property', 'og:site_name', siteName],
		['property', 'og:locale', 'en_GB'],
		['property', 'og:title', meta.title],
		['property', 'og:description', meta.description],
		['property', 'og:url', meta.url],
		['name', 'twitter:card', meta.image ? 'summary_large_image' : 'summary'],
		['name', 'twitter:title', meta.title],
		['name', 'twitter:description', meta.description],
	];
	if (meta.image) {
		tags.push(
			['property', 'og:image', siteUrl + meta.image],
			['property', 'og:image:alt', meta.imageAlt],
			['name', 'twitter:image', siteUrl + meta.image],
			['name', 'twitter:image:alt', meta.imageAlt],
		);
	}
	return tags;
}
